module.exports = __webpack_public_path__ + "img/bookshelf11.c6dd4622.jpg";